/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StudentSpecialBillDto } from '../models/StudentSpecialBillDto';
import type { StudentSpecialBillRequest } from '../models/StudentSpecialBillRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StudentSpecialBillRestControllerService {
  /**
   * getAll
   * @returns StudentSpecialBillDto OK
   * @throws ApiError
   */
  public static getAllUsingGet5(): CancelablePromise<Array<StudentSpecialBillDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/student-special-bill',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * saveStudentBill
   * @returns StudentSpecialBillDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static saveStudentBillUsingPost({
    studentSpecialBillRequests,
  }: {
    /**
     * studentSpecialBillRequests
     */
    studentSpecialBillRequests: Array<StudentSpecialBillRequest>;
  }): CancelablePromise<Array<StudentSpecialBillDto> | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/student-special-bill',
      body: studentSpecialBillRequests,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteById
   * @returns any OK
   * @throws ApiError
   */
  public static deleteByIdUsingDelete1({
    payableItemId,
    studentId,
    termId,
  }: {
    /**
     * payableItemId
     */
    payableItemId: string;
    /**
     * studentId
     */
    studentId: string;
    /**
     * termId
     */
    termId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/student-special-bill/student/{studentId}/{payableItemId}/{termId}',
      path: {
        payableItemId: payableItemId,
        studentId: studentId,
        termId: termId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
